import { createSlice } from "@reduxjs/toolkit";
import { addProductFromJSON,  deleteDraftProductApi,  fetchProductAiData,  fetchProductDetail,  getDraftProducts,  getProducts, getProductsByCampaignThunk, } from "./thunk";
export const initialState: any = {
    products: [],
    counts: {},
    productsCampain:[]
};

const ProductsSlice = createSlice({
    name: 'ProductsSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProducts.fulfilled, (state: any, action: any) => {
            const { data, counts } = action.payload;
            state.products = data;
            state.counts = counts;
        });

        builder.addCase(getProducts.rejected, (state: any, action: any) => {
            if (action.payload) {
                state.error = action.payload.error || null;
            }
        });
        builder.addCase(getProductsByCampaignThunk.fulfilled, (state: any, action: any) => {
            const { data, counts } = action.payload;
            state.productsCampain = data;
            state.counts = counts;
        });

        builder.addCase(getProductsByCampaignThunk.rejected, (state: any, action: any) => {
            if (action.payload) {
                state.error = action.payload.error || null;
            }
        });
        builder.addCase(addProductFromJSON.fulfilled, (state: any, action: any) => {
            state.product = action.payload;
        });
        builder
        .addCase(fetchProductDetail.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchProductDetail.fulfilled, (state, action) => {
          state.loading = false;
          state.productDetail = action.payload; 
        })
        .addCase(fetchProductDetail.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || 'Failed to fetch product detail';
        });
        builder.addCase(getDraftProducts.fulfilled, (state: any, action: any) => {
            const { data, counts } = action.payload;
            state.products = data;
            state.counts = counts;
        });

        builder.addCase(getDraftProducts.rejected, (state: any, action: any) => {
            if (action.payload) {
                state.error = action.payload.error || null;
            }
        });
        builder.addCase(deleteDraftProductApi.fulfilled, (state: any, action: any) => {
            const idToDelete = action.payload;
            if (idToDelete) {
              state.products = state.products.filter((product: any) => product._id !== idToDelete);
            } 
          })
        builder.addCase(deleteDraftProductApi.rejected, (state: any, action: any) => {
            state.error = action.payload.error || 'Failed to delete product';
        });
                builder.addCase(fetchProductAiData.fulfilled, (state: any, action: any) => {
            const idToDelete = action.payload;
            if (idToDelete) {
              state.products = state.products.filter((product: any) => product._id !== idToDelete);
            } 
          });
        builder.addCase(fetchProductAiData.rejected, (state: any, action: any) => {
            state.error = action.payload.error || 'Failed to delete product';
        });

    }
});

export default ProductsSlice.reducer;